import { createContext, useContext } from "react";

import useRuleWizard from "../hooks/useRuleWizard";

const RuleWizardContext = createContext(null);

export const useRuleWizardContext = () => {
	const context = useContext(RuleWizardContext);
	if (!context) {
		throw new Error("useRuleWizardContext must be used within a RuleWizardProvider");
	}
	return context;
};

export const RuleWizardProvider = ({ children, editedId }) => {
	const ruleWizard = useRuleWizard(editedId);
	return (
		<RuleWizardContext.Provider value={ruleWizard}>
			{children}
		</RuleWizardContext.Provider>
	);
};